import { apiFetch, markLoggedIn, clearLoggedIn } from "./client";

export type CurrentUser = {
  username: string;
  full_name: string | null;
  disabled: boolean | null;
  role: string;
};

type TokenResponse = { access_token: string; token_type: string };

export async function login(username: string, password: string): Promise<TokenResponse> {
  const body = new URLSearchParams();
  body.set("username", username);
  body.set("password", password);
  const res = await apiFetch<TokenResponse>("/api/token", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: body.toString(),
  });
  // Das Session-Cookie (HttpOnly) hat der Server gesetzt; hier nur Routing-Flag.
  markLoggedIn();
  return res;
}

export async function fetchCurrentUser(): Promise<CurrentUser> {
  return apiFetch<CurrentUser>("/api/me");
}

export async function logout(): Promise<void> {
  try {
    await apiFetch("/api/logout", { method: "POST" });
  } catch {
    // Server-Logout best-effort: lokalen Login-Status in jedem Fall verwerfen.
  }
  clearLoggedIn();
  window.location.assign("/app/login");
}
